import { apiGetAuditLog, apiGetAuditLogs } from "@lib/api/monitoring";
import { UseQueriesProps } from "@lib/types/General";
import { useQuery } from "@tanstack/react-query";

export const useAuditLogQueries = (props: UseQueriesProps) => {
  const { queryKey, params, id, enabled = true } = props;
  const queryKeys = queryKey || ["audit-log", JSON.stringify(params) || id];
  // const queryClient = useQueryClient();

  const auditLogQuery = useQuery({
    queryFn: () => apiGetAuditLog(params),
    queryKey: queryKeys,
    enabled: !!params && !!enabled,
  });

  const auditLogsQuery = useQuery({
    queryFn: () => apiGetAuditLogs(params),
    queryKey: queryKeys,
    enabled: !!params && !!enabled,
  });

  return {
    auditLogQuery,
    auditLogsQuery,
  };
};
